import { render, staticRenderFns } from "./PendingIncome.vue?vue&type=template&id=63368590&scoped=true&"
import script from "./PendingIncome.vue?vue&type=script&lang=js&"
export * from "./PendingIncome.vue?vue&type=script&lang=js&"
import style0 from "./PendingIncome.vue?vue&type=style&index=0&id=63368590&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63368590",
  null
  
)

export default component.exports